module.exports = __webpack_public_path__ + "media/images/athletes/2384-e8a70e85aa2694737835d918ebc3f567.png";